export default {
  back: 'Назад',
  tagsTitle: 'Читайте більше за тегами'
}
